import React from "react";
import { Link } from "react-router-dom";
import { PublicHeader } from "@/components/PublicHeader";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";
import { SEO_HOW_IT_WORKS } from "@/lib/seo-defs";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ArrowRight, FileSearch, Users, Briefcase, BarChart3 } from "lucide-react";

const STEPS = [
  { icon: FileSearch, num: 1, t: "Raccontaci la tua azienda", d: "Completa il check-up gratuito (8 step, ~7 minuti). Descrivi la sfida che vuoi affrontare e i tuoi obiettivi." },
  { icon: Users, num: 2, t: "Individuiamo la priorità", d: "Il sistema suggerisce il ruolo manageriale più utile. Il team CXOORA valida e contestualizza." },
  { icon: Briefcase, num: 3, t: "Selezioniamo il manager", d: "Calcoliamo un match score basato su ruolo, settore, esperienza, disponibilità e budget. Riceverai una shortlist curata di max 3 manager senior." },
  { icon: BarChart3, num: 4, t: "Misuriamo i risultati", d: "Una volta avviato il progetto, gestisci milestone, KPI, documenti, messaggi e timeline da un workspace condiviso." },
];

export default function HowItWorksPage() {
  return (
    <div className="min-h-screen">
      <SEO {...SEO_HOW_IT_WORKS} />
      <PublicHeader />
      <section className="pt-28 pb-12 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <Badge className="bg-[#EAF0FF] text-[#2D6BFF] border-0">Come funziona</Badge>
          <h1 className="mt-4 font-display text-4xl sm:text-5xl font-bold tracking-tight text-slate-900">
            Un percorso semplice in quattro passi.
          </h1>
          <p className="mt-5 text-lg text-slate-600">Dall'analisi del bisogno al monitoraggio dei risultati, ogni passaggio è chiaro e supportato dal team CXOORA.</p>
        </div>
      </section>
      <section className="py-12 bg-[#F6F8FC]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 space-y-5">
          {STEPS.map(s => {
            const Icon = s.icon;
            return (
              <div key={s.num} className="cxo-card p-6 sm:p-7 flex gap-4 sm:gap-6 items-start">
                <div className="shrink-0 w-12 h-12 rounded-xl bg-[#2D6BFF] text-white flex items-center justify-center">
                  <Icon size={22} />
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <span className="text-xs font-semibold uppercase tracking-wider text-slate-500 cxo-tabular">Step 0{s.num}</span>
                  </div>
                  <h3 className="mt-1 text-xl font-semibold text-slate-900">{s.t}</h3>
                  <p className="mt-2 text-slate-600 leading-relaxed">{s.d}</p>
                </div>
              </div>
            );
          })}
          <div className="flex justify-center pt-4">
            <Link to="/checkup"><Button size="lg" className="bg-[#2D6BFF] hover:bg-[#1F57F2] text-white h-12 px-6">Avvia il check-up <ArrowRight size={16} className="ml-2" /></Button></Link>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
